import type { School, Settings } from "./types";
import { fitTier, type Tier } from "./fitTier";

export type Proximity = "Close" | "Regional" | "Far" | "Unknown";

export function proximity(bucket: string | null): Proximity {
  if (!bucket) return "Unknown";
  if (/close/i.test(bucket)) return "Close";
  if (/regional/i.test(bucket)) return "Regional";
  if (/far|flight/i.test(bucket)) return "Far";
  return "Unknown";
}

export interface DerivedSchool {
  school: School;
  tier: Tier;
  proximity: Proximity;
  lastInteraction: string | null;
  nextFollowUp: string | null;
}

export function derive(school: School, settings: Settings): DerivedSchool {
  const sorted = [...school.interactions].sort((a, b) => b.date.localeCompare(a.date));
  const followUps = school.interactions
    .map((i) => i.followUpDate)
    .filter((d): d is string => !!d)
    .sort();
  return {
    school,
    tier: fitTier(school, settings.assumptions.tierThresholds),
    proximity: proximity(school.distance_bucket),
    lastInteraction: sorted[0]?.date ?? null,
    nextFollowUp: followUps[0] ?? null,
  };
}
